(() => {
  const finalBindings = new WeakMap();

  const readVariants = (purchase) => {
    const node = purchase?.querySelector('[data-cv-s4-6cam-variants]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (_) {
      return [];
    }
  };

  const initFaq = (root = document) => {
    root.querySelectorAll('[data-cv-s4-6cam-faq]:not([data-cv-s4-6cam-ready])').forEach((list) => {
      list.setAttribute('data-cv-s4-6cam-ready', 'true');

      list.addEventListener('toggle', (event) => {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement)) return;

        if (!opened.open || list.dataset.multiple === 'true') return;

        list.querySelectorAll('details[open]').forEach((item) => {
          if (item !== opened) item.open = false;
        });
      }, true);
    });
  };

  const initFinalCta = (root = document) => {
    root.querySelectorAll('[data-cv-s4-6cam-final-cta]').forEach((cta) => {
      const previous = finalBindings.get(cta);
      previous?.abort.abort();
      previous?.observer.disconnect();
      finalBindings.delete(cta);
      cta.removeAttribute('data-cv-s4-6cam-ready');

      const finalButton = cta.querySelector('[data-cv-s4-6cam-final-add]');
      const finalPrice = cta.querySelector('[data-cv-s4-6cam-final-price]');
      const status = cta.querySelector('[data-cv-s4-6cam-final-status]');
      const purchase = [...document.querySelectorAll('[data-cv-s4-6cam-controller]')]
        .find((node) => node.dataset.productId === cta.dataset.productId);
      const variantInput = purchase?.querySelector('[data-cv-s4-6cam-variant-input]');
      const variants = readVariants(purchase);

      if (!finalButton || !purchase || !variantInput) return;

      const abort = new AbortController();
      const signal = abort.signal;
      cta.setAttribute('data-cv-s4-6cam-ready', 'true');

      const currentVariant = () => variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants[0];
      const syncVariant = () => {
        const variant = currentVariant();
        if (finalPrice && variant?.priceFormatted) finalPrice.textContent = variant.priceFormatted;
        const unavailable = !variant?.available;
        finalButton.disabled = unavailable;
        finalButton.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      };
      const syncPurchaseState = () => {
        const mainButton = purchase.querySelector('[data-cv-s4-6cam-add]');
        if (!mainButton) return;
        const busy = mainButton.getAttribute('aria-busy') === 'true' || mainButton.hasAttribute('data-added');
        const unavailable = !currentVariant()?.available;
        finalButton.disabled = busy || unavailable;
        finalButton.setAttribute('aria-disabled', busy || unavailable ? 'true' : 'false');
        finalButton.setAttribute('aria-busy', busy ? 'true' : 'false');
        if (busy && status) status.textContent = 'Adding through the secure product form…';
      };

      variantInput.addEventListener('change', () => {
        syncVariant();
        syncPurchaseState();
      }, { signal });

      finalButton.addEventListener('click', () => {
        if (status) status.textContent = 'Adding through the secure product form…';
      }, { signal });

      const purchaseObserver = new MutationObserver(() => {
        syncPurchaseState();
        const error = purchase.querySelector('[ref="addToCartTextError"]')?.textContent?.trim();
        if (error && status) status.textContent = error;
      });
      purchaseObserver.observe(purchase, {
        attributes: true,
        attributeFilter: ['aria-busy', 'data-added', 'disabled'],
        childList: true,
        characterData: true,
        subtree: true,
      });
      finalBindings.set(cta, { abort, observer: purchaseObserver });

      syncVariant();
      syncPurchaseState();
    });
  };

  const init = (root = document) => {
    initFaq(root);
    initFinalCta(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFaq(event.target);
    initFinalCta(document);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const ctas = event.target.matches?.('[data-cv-s4-6cam-final-cta]')
      ? [event.target]
      : [...event.target.querySelectorAll?.('[data-cv-s4-6cam-final-cta]') || []];
    const purchaseWasUnloaded = event.target.matches?.('[data-cv-s4-6cam-controller]')
      || event.target.querySelector?.('[data-cv-s4-6cam-controller]');
    const targets = purchaseWasUnloaded
      ? [...document.querySelectorAll('[data-cv-s4-6cam-final-cta]')]
      : ctas;
    targets.forEach((cta) => {
      const binding = finalBindings.get(cta);
      binding?.abort.abort();
      binding?.observer.disconnect();
      finalBindings.delete(cta);
      cta.removeAttribute('data-cv-s4-6cam-ready');
    });
  });
})();
